
import { defineComponent } from 'vue';

export default defineComponent({
	name: 'required-input-phone',
	props: {
		control: {
			type: Object,
			required: true
		},
		dense: Boolean,
		showInvalidRequiredInput: Boolean
	},
	data() {
		return {
			isChangeInput: false
		};
	},
	emits: ['change-control'],
	computed: {
		value: {
			get(): string {
				return this.control.value;
			},
			set(value: string) {
				this.isChangeInput = true;
				const payload = {
					type: 'phone',
					isValid: this.validatePhone(value),
					value
				};
				this.$emit('change-control', payload);
			}
		},
		showError(): boolean {
			if (this.showInvalidRequiredInput) {
				return !this.validatePhone(this.value);
			}
			return this.isChangeInput && !this.validatePhone(this.value);
		}
	},
	methods: {
		validatePhone(value: string): boolean {
			return value.length > 7;
		}
	}
});
